module.exports = __webpack_public_path__ + "static/media/pallet.c84ae1a8.svg";